import React from 'react'
// import Spinner from '../Spinner'
import styles from './CommonLoader.module.css'
import CubeLoader from '../CubeLoader/CubeLoader'

const CommonLoader = ({ changeOrientation }) => {
  return (
    // <div className="flex justify-center items-center w-screen h-screen">
    // {/* <Spinner /> */}
    <div className={`${styles["loader-container"]} ${changeOrientation ? styles["mobile-loader-container"] : ""}`}>
      <CubeLoader />
    </div>
    // </div>
  )
}

export default CommonLoader